var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnUpvoted = function SvgIcnUpvoted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 8.25c0-.647-.525-1.167-1.166-1.167H10.98l.56-2.665a.878.878 0 0 0-.24-.805L10.683 3 6.844 6.838a1.164 1.164 0 0 0-.344.829V13.5a1.167 1.167 0 0 0 1.167 1.167h5.25c.484 0 .898-.292 1.073-.712l1.762-4.113c.052-.134.081-.274.081-.425V8.25ZM3 14.667h2.333v-7H3v7Z",
    fill: "#292525"
  })));
};
export default SvgIcnUpvoted;